import React, { useContext, useEffect } from 'react';
import { OrganizationContext } from '../../../containers/Context/OrganizationContext';
import HsSelect from '../../Form/HsSelect';
import { strings } from '../../../assets/strings/all';

function PostTypeSelector(props) {
  const { organization } = useContext(OrganizationContext);
  const { onChange } = props;
  const { visibilityStatuses = [] } = organization || {};
  const { cases } = strings;

  const formattedLabel = (option) => {
    const { name, description } = option;

    return (
      <div className="select-option-wrapper">
        <div className="select-option-name">{name}</div>
        <div className="select-option-description">{description}</div>
      </div>
    );
  };
  useEffect(() => {
    if (props.value && !props.value?.name) {
      onChange({ name: props.value });
    }
  }, []);

  return (
    <>
      <HsSelect
        label={cases.type}
        // placeholder={props.value?.name}
        options={[
          {
            label: cases.type,
            options: [
              {
                name: cases.question,
                slug: 'Question',
              },
              {
                name: cases.case,
                slug: 'Case',
              },
            ],
          },
        ]}
        getOptionLabel={(option) => formattedLabel(option)}
        defaultValue={props.value}
        onChange={onChange}
        isClearable={false}
        {...props}
        selected={props.value}
      />
    </>
  );
}

export default PostTypeSelector;
